/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { MailCheck } from "./MailCheck";

export const MailColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { absenteeismValues, setAbsenteeismValues }
) => (
  <MailCheck
    id={row.id}
    parentId={row.parentId}
    studentName={row.studentName}
    absenteeismValues={absenteeismValues}
    setAbsenteeismValues={setAbsenteeismValues}
  />
)